module.exports = __webpack_public_path__ + "img/sap.723827e5.svg";